import { render, staticRenderFns } from "./Attendence.vue?vue&type=template&id=6f8adf5b&scoped=true"
import script from "./Attendence.vue?vue&type=script&lang=js"
export * from "./Attendence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8adf5b",
  null
  
)

export default component.exports